import { Page, Tabs } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';

import { pwaMediaQuery } from 'app/middleware/visibility/utils/helpers';
import { FeatureFlagName } from 'utils/featureFlagging/featureFlags';
import { useMediaQuery } from 'utils/mediaQuery';
import { useAppNavigate } from 'utils/url/useAppNavigate';

import { PreferencesConnectedDevicesRoutes } from './preferencesConnectedDevices.routes';

type TabIDs = 'busylight' | 'jabra';
type Tab = {
  readonly id: TabIDs;
  readonly label: string;
  readonly featureFlag?: FeatureFlagName;
};

const connectedDevicesTabs = [
  {
    id: 'busylight',
    label: 'Busylight',
  },
  {
    id: 'jabra',
    label: 'Jabra',
  },
] as const;

type PreferencesTab = (typeof connectedDevicesTabs)[number]['id'];

export const PreferencesConnectedDevicesView = (): JSX.Element => {
  const [isOpenedInPWA] = useMediaQuery(pwaMediaQuery);
  const navigate = useAppNavigate();

  const handleTabChange = (value: string) => {
    const tab = value as (typeof connectedDevicesTabs)[number]['id'];
    navigate({
      path: `/settings/preferences/devices/${tab}`,
    });
  };

  const selectedTab = (location.pathname?.split('/').pop() ??
    connectedDevicesTabs[0]) as PreferencesTab;

  const hasJabraAccess = isOpenedInPWA;

  const guardedTabs: Tab[] = useMemo(() => {
    return connectedDevicesTabs.filter((tab) => {
      if (tab.id === 'jabra') {
        return hasJabraAccess;
      }
      return true;
    });
  }, [hasJabraAccess]);

  return (
    <>
      {guardedTabs.length > 1 && (
        <Page.Tabs>
          <Tabs
            tabs={guardedTabs}
            selectedId={selectedTab}
            onChange={handleTabChange}
          />
        </Page.Tabs>
      )}
      <Page.Body>
        <PreferencesConnectedDevicesRoutes hasJabraAccess={hasJabraAccess} />
      </Page.Body>
    </>
  );
};
